import { render, staticRenderFns } from "./UpdateSchedulerGtps.vue?vue&type=template&id=397df61a&scoped=true"
import script from "./UpdateSchedulerGtps.vue?vue&type=script&lang=js"
export * from "./UpdateSchedulerGtps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397df61a",
  null
  
)

export default component.exports